/* eslint-disable no-console */
import {
  Body,
  Content,
  MenuActions,
  Header,
  Subtitle,
  TextArea,
  WrapIcon,
  Footer,
} from './styles';

import geoAlert from 'services/utils/alert';
import { measureArea, measureLength } from 'services/utils/measures';

import { Box } from './components/Box';
import { BoxInfo } from './components/BoxInfo';
import { CustomTable } from './components/CustomTable';
import { SessionDrawer } from './components/SessionDrawer';
import ProtectedAreasReportView from './views/ProtectedAreasReportView';
import LogoGeobahia from './views/ProtectedAreasReportView/imgs/geobahia-logo-print.png';

import ButtonTooltip from '../../ButtonTooltip';

import Icon from '@map/components/Icons';
/**
 * useState é um hook que nos permite rastrear o estado em um
 * componente de função, o estado geralmente se refere a dados ou
 * propriedads que precisam ser rastreador em um aplicativo.
 *
 * useEffect é um hook que permite executar efeitos colaterais em
 * seus componentes, por exemplo: buscar dados, atualizar diretamente
 * o DOM e cronômetros, ele aceita dois argumentos o segundo é opcional.
 */
import CustomDrawer from 'components/Drawer ';
import { useState, useEffect } from 'react';
import Scale from 'views/MapView/components/MapArea/components/Scale';
/**
 *  useMap é um hook personalizado criado para gerenciar a comunicação
 *  dos componentes com o mapa.
 */
import { useMap, useModule } from 'views/MapView/hooks';

/**
 * Componente responsável por iniciar configuração da Restrição Ambiental
 *
 * @param {string} mapContext Context
 * @param {boolean} isActive Verificação
 * @param {boolean} setIsActive Setar o estado
 * @returns Report com as configurações da Restrição Ambiental
 */


const IconLose = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="12"
    height="12"
    viewBox="0 0 17 18"
    fill="none"
  >
    <line
      y1="-0.75"
      x2="12"
      y2="-0.75"
      transform="matrix(-0.707107 0.707107 0.707107 0.707107 13.3125 5.20703)"
      stroke="#5E6366"
      strokeWidth="1.5"
    />
    <line
      y1="-0.75"
      x2="12"
      y2="-0.75"
      transform="matrix(0.707107 0.707107 0.707107 -0.707107 4.82812 4.09375)"
      stroke="#5E6366"
      strokeWidth="1.5"
    />
  </svg>
);

const InemaLogo = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="49"
    height="13"
    viewBox="0 0 49 13"
    fill="none"
  >
    <path
      d="M3.70706 3.71875H0.675781V12.4175H3.70706V3.71875Z"
      fill="#0069B4"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3.81108 1.71964C3.81412 1.93735 3.7728 2.15334 3.68975 2.35401C3.60669 2.55468 3.48369 2.73568 3.32849 2.88561C3.17924 3.04037 3.00077 3.16282 2.8038 3.24561C2.60683 3.32839 2.39544 3.3698 2.18234 3.36734C1.89463 3.37071 1.61131 3.29548 1.36193 3.14948C1.11829 3.00757 0.916289 2.80208 0.776788 2.55423C0.633686 2.30037 0.55976 2.01227 0.562638 1.71964C0.559825 1.50308 0.600053 1.28816 0.680909 1.0878C0.761764 0.887444 0.88158 0.705769 1.03316 0.553681C1.18067 0.395116 1.35904 0.269565 1.5569 0.185038C1.75476 0.10051 1.96777 0.0588618 2.18234 0.0627491C2.39622 0.0605821 2.60826 0.103026 2.80539 0.187463C3.00252 0.271899 3.18055 0.396536 3.32849 0.553681C3.48282 0.70429 3.60525 0.885416 3.68824 1.08593C3.77123 1.28644 3.81304 1.50209 3.81108 1.71964Z"
      fill="#95C11F"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M13.6801 12.4208H10.6639V7.72935C10.6728 7.30017 10.5937 6.87382 10.4317 6.47747C10.2779 6.12154 9.94004 5.94358 9.42125 5.94358C9.19636 5.93958 8.97353 5.98786 8.76975 6.08472C8.58351 6.17787 8.41339 6.30119 8.26605 6.44986C8.12955 6.58081 8.00441 6.7235 7.89204 6.87635C7.78949 7.01136 7.68694 7.15864 7.59042 7.31206V12.4208H4.57422V3.72211H7.59042V4.96785C7.98377 4.50967 8.46654 4.13977 9.00803 3.88167C9.51581 3.66957 10.0608 3.56516 10.6096 3.57483C12.6586 3.57483 13.6831 4.82262 13.6831 7.31819L13.6801 12.4208Z"
      fill="#0069B4"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M20.5119 7.29776C20.5361 6.81686 20.3918 6.34282 20.1048 5.95997C19.9595 5.79142 19.7782 5.65898 19.5749 5.57281C19.3715 5.48664 19.1514 5.44904 18.9315 5.4629C18.7066 5.45601 18.4829 5.49756 18.275 5.58481C18.0671 5.67206 17.8796 5.80305 17.725 5.96917C17.405 6.33319 17.2373 6.80986 17.2575 7.29776H20.5119ZM23.3502 8.83192H17.3178C17.4352 9.36009 17.7444 9.82367 18.1834 10.1298C18.6369 10.4656 19.185 10.6432 19.7458 10.6361C20.9209 10.5972 22.0736 10.2988 23.124 9.76162V11.6671C22.6084 11.9317 22.069 12.1454 21.5133 12.3053C20.7263 12.5161 19.9139 12.6121 19.1004 12.5906C18.1688 12.619 17.2448 12.4135 16.4099 11.9923C15.7098 11.6323 15.1319 11.0668 14.751 10.3692C14.3834 9.65099 14.2008 8.84975 14.2201 8.04029C14.2063 7.23803 14.3953 6.44561 14.7691 5.73905C15.1505 5.05008 15.7291 4.49566 16.428 4.14966C17.2672 3.74316 18.1894 3.54545 19.1185 3.57281C19.8129 3.57352 20.4987 3.7296 21.1272 4.02999C21.7953 4.35384 22.3522 4.87445 22.7258 5.52427C23.1726 6.34158 23.3886 7.26857 23.3502 8.20291V8.83192Z"
      fill="#0069B4"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M39.3444 12.4264H36.3282V7.78705C36.359 7.30697 36.2544 6.82792 36.0266 6.4063C35.922 6.25304 35.7799 6.13023 35.6143 6.05004C35.4487 5.96985 35.2654 5.93506 35.0825 5.94912C34.8923 5.94082 34.7024 5.97099 34.5238 6.03788C34.3452 6.10477 34.1814 6.20705 34.0419 6.3388C33.7414 6.6363 33.4715 6.96427 33.2366 7.31759V12.4264H30.2204V7.78705C30.2463 7.31741 30.1517 6.84899 29.9459 6.42778C29.8411 6.26381 29.6938 6.13239 29.5204 6.04795C29.3469 5.96351 29.1539 5.92932 28.9626 5.94912C28.7539 5.94871 28.5478 5.99589 28.3594 6.0872C28.1921 6.16517 28.0375 6.26864 27.9009 6.39403C27.7467 6.55128 27.6036 6.71943 27.4726 6.89723C27.3067 7.12122 27.1982 7.2593 27.1529 7.31759V12.4264H24.1367V3.72765H27.1529V4.97339C27.5443 4.53081 28.0152 4.16839 28.5404 3.90562C29.0524 3.67338 29.6086 3.55917 30.1691 3.57117C30.4487 3.57 30.7276 3.59776 31.0016 3.65401C31.2714 3.70865 31.5324 3.80161 31.7767 3.93016C32.0375 4.06579 32.2724 4.24762 32.4705 4.46712C32.6742 4.70712 32.8336 4.98258 32.941 5.28023C33.3683 4.7735 33.8785 4.34581 34.4491 4.01608C35.0081 3.72296 35.6301 3.57636 36.2588 3.58958C36.8583 3.5692 37.4522 3.71334 37.9781 4.00687C38.4398 4.28736 38.7996 4.71263 39.0036 5.21886C39.2395 5.82899 39.3523 6.48116 39.3353 7.13656L39.3444 12.4264Z"
      fill="#0069B4"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M44.6698 10.1166C44.4842 10.3476 44.2553 10.5388 43.9964 10.6789C43.7375 10.819 43.4537 10.9053 43.1617 10.9328C42.9572 10.9624 42.7487 10.9459 42.5512 10.8843C42.3536 10.8228 42.1718 10.7179 42.0186 10.5769C41.8743 10.4023 41.7822 10.1894 41.7531 9.96322C41.6982 9.67328 41.7532 9.37292 41.907 9.1225C42.1379 8.84593 42.435 8.63457 42.7696 8.50884C42.7877 8.50884 43.0531 8.39838 43.5719 8.20201C44.0378 8.03003 44.4838 7.80676 44.9021 7.53618H44.9171L45.0438 8.44134C45.0995 8.73258 45.0958 9.03234 45.033 9.32208C44.9702 9.61182 44.8497 9.88538 44.6789 10.1258L44.6698 10.1166ZM48.2229 10.3253C48.1513 10.3284 48.0807 10.3072 48.0223 10.2649C47.9638 10.2227 47.9209 10.1619 47.9002 10.0921C47.8322 9.86038 47.8026 9.61877 47.8127 9.37717V6.02043C47.8282 5.63273 47.7509 5.24701 47.5876 4.8964C47.4242 4.54579 47.1795 4.24079 46.8747 4.00761C46.2503 3.51974 45.3213 3.27734 44.0817 3.27734C43.5973 3.2772 43.1138 3.32032 42.6369 3.40621C42.1743 3.49053 41.7208 3.61999 41.2826 3.79282C40.8548 3.96542 40.4496 4.19112 40.0761 4.46479V6.82433C40.5341 6.3644 41.0578 5.97751 41.6295 5.67677C42.1989 5.38113 42.8301 5.22957 43.4694 5.23494C44.0274 5.23494 44.3923 5.3546 44.5612 5.59393C44.7446 5.88948 44.8322 6.23613 44.8116 6.585C44.703 6.64273 44.5912 6.69396 44.4768 6.73841C44.3712 6.7783 44.2083 6.83353 43.9942 6.9041L43.0411 7.21094C42.4321 7.39936 41.8365 7.63003 41.2585 7.90131C40.8418 8.10077 40.4755 8.39466 40.1877 8.76044C39.905 9.14473 39.7593 9.61544 39.7745 10.0952C39.7759 10.4521 39.8552 10.8042 40.0068 11.1261C40.1824 11.4819 40.4643 11.7719 40.8121 11.9546C41.2793 12.1922 41.7983 12.3052 42.3202 12.2829C42.8529 12.3029 43.3841 12.2142 43.8826 12.0221C44.2726 11.8546 44.6372 11.6314 44.9654 11.3593C45.0412 11.6146 45.1828 11.8445 45.3756 12.0251C45.681 12.2381 46.0509 12.3338 46.4192 12.2952C46.8748 12.3034 47.3294 12.2487 47.7705 12.1325C48.1864 12.0113 48.5961 11.869 48.9981 11.706V10.0798C48.7594 10.2186 48.4938 10.3023 48.2199 10.3253H48.2229Z"
      fill="#0069B4"
    />
  </svg>
);

export const Ronmentalrestrict = ({ mapContext, isActive, setIsActive }) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const [layer, setLayer] = useState(null);  
  const [infoLayer, setInfoLayer] = useState(null);
  const [activeReport, setActiveReport] = useState(false);
  const [subtitle, setSubtitle] = useState('');
  const [comment, setComment] = useState('');
  const [intersectionsRestrictionAreas, setIntersectionsRestrictionAreas] = useState([]);
  const [errorCrossingLayers, setErrorCrossingLayers] = useState([]);
  const [mapReport, setMapReport] = useState(false);
  const {  getElement } = useModule();
 const dataProtectedAreasReport = getElement('CPN-TB-P-PROTECTED-AREAS-REPORT')
  
  const { layers } = useMap();

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
    setIsActive(false);    
  };

  const handleClose = () => {
    setAnchorEl(null);
    setIsActive(false);    
  };

  /**
   * Habilita ferramenta de acordo com a camada selecionada
   */
  useEffect(() => {
    setActiveReport(false);
    let selectedLayers = layers.filter((l) => l.isSelected && l.visible);
    if (
      selectedLayers.length === 1 &&      
      selectedLayers[0].dataType === 'Polygon' && 
      ['importada', 'criada'].includes(selectedLayers[0].type) &&
      selectedLayers[0].leafletLayer.getLayers().length === 1
    ) {      
      setLayer(selectedLayers[0]);      
    } else {
      setLayer(null);
      setActiveReport(false);
      
    }
  }, [layers]);

  useEffect(() => {    
    if (!activeReport) {
      setSubtitle('');
      setComment('');
      if(intersectionsRestrictionAreas.length) {
        setIntersectionsRestrictionAreas([]);
        setErrorCrossingLayers([]);
      }
    }
  }, [activeReport, intersectionsRestrictionAreas]);

  useEffect(() => {    
    if (layer) {
      setInfoLayer({
        geometryType: getGeometryTypeLayer(layer),
        dataInfo: getDataInfoLayer(layer)
      });
    }
  }, [layer]);

  const getGeometryTypeLayer = (layer) => {
    return layer.dataType === 'Polygon'
            ? 'Polígono'
            : layer.dataType === 'LineString'
              ? 'Linha'
              : 'Ponto';
  };

  const getDataInfoLayer = (layer) => {
    let arrDataInfo = [];    

    if (layer.dataType === 'Polygon') {
      let areaInputLayer = measureArea(layer.leafletLayer.getLayers()[0].feature.geometry.coordinates[0], true) / 10000;
      let parsedAreaInputLayer = parseFloat(areaInputLayer.toFixed(2)).toLocaleString('pt-br') + " ha";
      let lenghtInputLayer = measureLength(layer.leafletLayer.getLayers()[0].feature.geometry.coordinates[0], true) / 1000;
      let parsedLenghtInputLayer = parseFloat(lenghtInputLayer.toFixed(2)).toLocaleString('pt-br') + " km";
      arrDataInfo.push(['Área', parsedAreaInputLayer], ['Perímetro', parsedLenghtInputLayer]);
    } else if (layer.dataType === 'LineString') {
      let lenghtInputLayer = measureLength(layer.leafletLayer.getLayers()[0].feature.geometry.coordinates, true) / 1000;
      let parsedLenghtInputLayer = parseFloat(lenghtInputLayer.toFixed(2)).toLocaleString('pt-br') + " km";      
      arrDataInfo.push(['Comprimento', parsedLenghtInputLayer]);
    } else {
      let featurePoint = layer.leafletLayer.getLayers()[0];
      arrDataInfo.push(['Latitude', (featurePoint.getLatLng().lat).toFixed(6)], ['Longitude', (featurePoint.getLatLng().lng).toFixed(6)]);      
    }

    return arrDataInfo;
  };
  
  return (
    <div style={{ display: 'flex' }}>
      <ButtonTooltip
        tooltip="Relatório Preliminar de Análise Ambiental"
        description="realiza o cruzamento de uma camada criada/importada com as bases temáticas ambientais."
        onClick={(e) => {
          if(dataProtectedAreasReport?.configuracao?.selectedLayers && dataProtectedAreasReport?.configuracao?.selectedLayers.length > 0){
            setActiveReport(!activeReport);
            anchorEl === null ? handleClick(e) : handleClose();
          }else{
            geoAlert({
              message: 'Relatório sem camadas configuradas.',
            });
          }          
        }}        
        disabled={!layer}
      >
        <Icon
          i="map-toolbar-report"
          width="17"
          height="17"
          style={{ verticalAlign: 'middle' }}
        />
      </ButtonTooltip>

      <CustomDrawer        
        isActive={activeReport}
        config={{
          width: '585px',
          top: '86px',
          position: 'right',
          zIndex: 1500,
        }}
      >
        <Content>
        <MenuActions>
            <div
              className="button minimize"
              onClick={() => {
                setActiveReport(false);
              }}
            >
              {/* <Icon
                i="map-toolbar-Minimize"
                width="8"
                height="24"
                style={{ verticalAlign: 'middle' }}
              /> */}
            </div>

            <div className="btn-group">
              <div title="Aumentar Zoom" className="ZoomInIcon lupa">
                {/* <Icon
                  i="map-toolbar-ZoomIn"
                  width="17"
                  height="17"
                  style={{ verticalAlign: 'middle' }}
                /> */}
              </div>

              <div title="Diminuir Zoom" className="ZoomOutIcon lupa">
                {/* <Icon
                  i="map-toolbar-ZoomOut"
                  width="17"
                  height="17"
                  style={{ verticalAlign: 'middle' }}
                /> */}
              </div>

              <ProtectedAreasReportView 
                dataProtectedAreasReport={dataProtectedAreasReport}
                activeReport={activeReport}
                subtitle={subtitle}
                comment={comment}
                setMapReport={setMapReport}
                inputLayer={layer} 
                setIntersectionsRestrictionAreas={setIntersectionsRestrictionAreas}
                intersectionsRestrictionAreas={intersectionsRestrictionAreas}      
                setErrorCrossingLayers={setErrorCrossingLayers}
                errorCrossingLayers={errorCrossingLayers}
                infoLayer={infoLayer}
                onClose={() => {                  
                  setActiveReport(false);
                  setIntersectionsRestrictionAreas([]);
                  setErrorCrossingLayers([]);
                }} 
              />

              <div
                title="Fechar"
                className="button closed"
                onClick={() => {                  
                  setActiveReport(false);
                  setIntersectionsRestrictionAreas([]);
                  setErrorCrossingLayers([]);
                }}
              >
                <IconLose />
              </div>
            </div>
          </MenuActions>
          <Body>
            <Header>
              <span className="title">Relatório Preliminar de Análise Ambiental</span>
              <WrapIcon>
                <img src={LogoGeobahia} alt="logo" />
                <InemaLogo />
              </WrapIcon>
            </Header>
            <Subtitle>
              <input
                type="text"
                placeholder="Inserir subtítulo do projeto"
                value={subtitle}
                maxLength={80}
                onChange={(e) => {
                  setSubtitle(e.target.value);
                }}                
              />
              <span>Bahia, {new Date().toLocaleDateString()}</span>
            </Subtitle>
            <TextArea
              placeholder="Inserir comentário sobre o projeto"
              value={comment}
              maxLength={500}
              onChange={(e) => {
                setComment(e.target.value);
              }}              
            />
            <SessionDrawer
              configSessionDrawer={{
                title: 'Mapa de Localização',
                width: '168.891px',
                marginTitle: '0px 0px 12px 0px',
                marginSessionDrawer: '16px 0px 0px 0px',
              }}
            >
              <div className="mapa" id="map-location-report">
              </div>
              {mapReport && (                
                <div className="mapBottomRight">
                  <Scale map={mapReport} />          
                </div>                
              )}              
              {infoLayer && (    
                <BoxInfo
                  key={'Informações da geometria'}
                  dataBox={{
                    title: infoLayer.geometryType,
                    content: infoLayer.dataInfo,
                  }}
                />
              )}
            </SessionDrawer>
            <SessionDrawer
              configSessionDrawer={{
                title: 'Cruzamento de Alertas',
                width: '168.891px',
                marginTitle: '0px 0px 12px 0px',
                marginSessionDrawer: '16px 0px 0px 0px',
              }}
            >
              <div className="container-box">
                {intersectionsRestrictionAreas.map((ira) => (
                  <Box
                    key={ira.aliasLayer}
                    dataBox={{
                      title: ira.aliasLayer,
                      content: ira.valueIntersection,
                    }}
                  />
                ))}
              </div>
              {errorCrossingLayers.length > 0 &&
                <div className="container-error">
                  * Obs .: Camada(s) {errorCrossingLayers.join(", ")} indisponíveis ou com erro topológico.
                </div>
              }              
            </SessionDrawer>
            <SessionDrawer
              configSessionDrawer={{
                title: 'Atributos das Áreas de Restrição',
                width: '251px',
                marginTitle: '16px 0px 12px 0px',
                marginSessionDrawer: '0px 0px 0px 0px',
              }}
            >
              {/* {[...Array(3)].map((item) => (
                <CustomTable
                  key={item}
                  configTable={{
                    title: 'Zoneamento',
                    marginBottom: '24px', // 16px
                  }}
                >
                  <table className="table-header">
                    <thead>
                      <tr>
                        <th style={{ width: '10%' }}>ID</th>
                        <th style={{ width: '15%' }}>Nome</th>
                        <th style={{ width: '15%' }}>Restrição</th>
                        <th style={{ width: '10%' }}>Resolução</th>
                        <th style={{ width: '10%' }}>Área (ha)</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td style={{ width: '5%', padding: '6px 0px 0px 0px' }}>
                          7440
                        </td>
                        <td
                          style={{ width: '25%', padding: '6px 0px 0px 0px' }}
                        >
                          APA das Ilhas de Tinharé e Boipeba mais
                        </td>
                        <td
                          style={{ width: '20%', padding: '8px 0px 0px 0px' }}
                        >
                          Zona de proteção Rigorosa
                        </td>
                        <td
                          style={{ width: '20%', padding: '8px 8px 0px 0px' }}
                        >
                          Resolução CEPRAM nº 1.692 de 19 de junho de 1998
                        </td>

                        <td style={{ width: '5%' }}>10,53</td>
                      </tr>

                      <tr>
                        <td style={{ width: '5%', padding: '6px 0px 0px 0px' }}>
                          7440
                        </td>
                        <td
                          style={{ width: '25%', padding: '6px 0px 0px 0px' }}
                        >
                          APA das Ilhas de Tinharé e Boipeba mais
                        </td>
                        <td
                          style={{ width: '20%', padding: '8px 0px 0px 0px' }}
                        >
                          Zona de proteção Rigorosa
                        </td>
                        <td
                          style={{ width: '20%', padding: '8px 8px 0px 0px' }}
                        ></td>

                        <td style={{ width: '5%' }}>10,53</td>
                      </tr>
                    </tbody>
                  </table>
                </CustomTable>
              ))} */}
              {intersectionsRestrictionAreas.map((ira) => (                
                ira.dataTable.length > 0
                  && (<CustomTable
                        key={ira.aliasLayer}
                        configTable={{
                          title: ira.aliasLayer,
                          marginBottom: '24px', // 16px
                        }}
                      >
                        <table className="table-header">
                          <thead>
                            <tr>                              
                              {ira.columnsLabel[0].map((c, i) => (                                
                                <th key={i}>{c}</th>                                
                              ))}
                              {/* {ira.columnsLabel.map((col, i) => (
                                <div key={i}>{col}</div>
                              ))} */}
                              {/* // {ira.columnsLabel[0].map((c, i) => {
                              //   return (                                  
                              //       <th style={{ width: '10%' }}>{c}</th>                                  
                              //   );
                              // })} */}
                              {/* <th style={{ width: '10%' }}>ID</th>
                              <th style={{ width: '15%' }}>Nome</th>
                              <th style={{ width: '15%' }}>Restrição</th>
                              <th style={{ width: '10%' }}>Resolução</th>
                              <th style={{ width: '10%' }}>Área (ha)</th> */}
                            </tr>
                          </thead>
                          <tbody>
                            
                            {ira.dataTable.map((rowData, ri) => (      
                              <tr key={ri}>
                                {rowData.map((columnData, ci) => (
                                  <td key={ci} style={{ width: '5%', padding: '6px 0px 0px 0px' }}>{columnData}</td>    
                                ))}
                              </tr>                         
                              // <td key={i} style={{ width: '5%', padding: '6px 0px 0px 0px' }}>{d}</td>                          
                            ))}
                              {/* <td style={{ width: '5%', padding: '6px 0px 0px 0px' }}>
                                7440
                              </td>
                              <td
                                style={{ width: '25%', padding: '6px 0px 0px 0px' }}
                              >
                                APA das Ilhas de Tinharé e Boipeba mais
                              </td>
                              <td
                                style={{ width: '20%', padding: '8px 0px 0px 0px' }}
                              >
                                Zona de proteção Rigorosa
                              </td>
                              <td
                                style={{ width: '20%', padding: '8px 8px 0px 0px' }}
                              >
                                Resolução CEPRAM nº 1.692 de 19 de junho de 1998
                              </td>

                              <td style={{ width: '5%' }}>10,53</td> */}
                            

                            {/* <tr>
                              <td style={{ width: '5%', padding: '6px 0px 0px 0px' }}>
                                7440
                              </td>
                              <td
                                style={{ width: '25%', padding: '6px 0px 0px 0px' }}
                              >
                                APA das Ilhas de Tinharé e Boipeba mais
                              </td>
                              <td
                                style={{ width: '20%', padding: '8px 0px 0px 0px' }}
                              >
                                Zona de proteção Rigorosa
                              </td>
                              <td
                                style={{ width: '20%', padding: '8px 8px 0px 0px' }}
                              ></td>

                              <td style={{ width: '5%' }}>10,53</td>
                            </tr> */}
                          </tbody>
                        </table>
                      </CustomTable>)
              ))}
            </SessionDrawer>

            {/* <SessionDrawer
              configSessionDrawer={{
                title: 'Metodologia',
                width: '168.891px',
                marginTitle: '0px 0px 12px 0px',
                marginSessionDrawer: '-14px 0px 0px 0px',
              }}
            >
              <div className="textDefault">
                Donec ultricies nisl egestas viverra varius. Nunc vulputate
                blandit iaculis. Curabitur nec magna sed elit maximus tristique
                eu quis nisi. Aenean viverra fermentum sollicitudin. Maecenas
                sit amet laoreet ligula. Vivamus facilisis ut libero sit amet
                lacinia. Ut accumsan velit sem, vitae fermentum arcu euismod.
                Vivamus vulputate nulla ac rhoncus pellentesque. Integer
                ultricies lacus nec purus faucibus, vitae molestie turpis
                scelerisque. Proin aliquet ut ex quis interdum. Quisque quis
                lectus blandit tortor bibendum blandit. Nulla ut tristique ante.
              </div>
            </SessionDrawer>

            <SessionDrawer
              configSessionDrawer={{
                title: 'Metadados',
                width: '168.891px',
                marginTitle: '0px 0px 12px 0px',
                marginSessionDrawer: '16px 0px 0px 0px',
              }}
            >
              <div className="textDefault">
                Maecenas sit amet laoreet ligula. Donec ultricies nisl egestas
                viverra varius. Nunc vulputate blandit iaculis. Curabitur nec
                magna sed elit maximus tristique eu quis nisi. Aenean viverra
                fermentum sollicitudin. Uthert accumsan velit sem, vitae
                fermentum arcu euismod. Vivamus facilisis ut libero sit amet
                lacinia.
              </div>

              <CustomTable
                configTable={{
                  marginBottom: '16px',
                  marginTop: '24px',
                  padding: '8px 0px 0px 0px',
                }}
              >
                <table className="table-header">
                  <thead>
                    <tr>
                      <th style={{ width: '10%', paddingLeft: '6px' }}>Nome</th>
                      <th style={{ width: '20%' }}>Fonte</th>
                      <th style={{ width: '15%' }}>Data da Fonte</th>
                      <th style={{ width: '5%' }}>Atualização</th>
                    </tr>
                  </thead>

                  {[...Array(4)].map((item) => (
                    <>
                      <Divider />
                      <tbody>
                        <tr>
                          <td
                            colSpan={5}
                            style={{
                              width: '10%',
                              padding: '6px 6px 6px 6px',
                              marginTop: '24px',
                              background: '#EBF1FC',
                            }}
                          >
                            Território
                          </td>
                        </tr>
                        <tr>
                          <td style={{ width: '10%', padding: '6px' }}>
                            Municípios
                          </td>
                          <td style={{ width: '10%', padding: '6px' }}>IBGE</td>
                          <td style={{ width: '10%', padding: '6px' }}>2019</td>
                          <td style={{ width: '10%', padding: '6px' }}>
                            03/2023
                          </td>
                        </tr>
                        <tr>
                          <td style={{ width: '10%', padding: '6px' }}>
                            Bacia Hidrográfica
                          </td>
                          <td style={{ width: '20%', padding: '6px' }}>
                            Biomas Brasileiros do IBGE
                          </td>
                          <td style={{ width: '10%', padding: '6px' }}>2019</td>
                          <td style={{ width: '10%', padding: '6px' }}>
                            03/2023
                          </td>
                        </tr>
                        <tr>
                          <td style={{ width: '10%', padding: '6px' }}>
                            Municípios
                          </td>
                          <td style={{ width: '10%', padding: '6px' }}>IBGE</td>
                          <td style={{ width: '10%', padding: '6px' }}>2019</td>
                          <td style={{ width: '5%', padding: '6px' }}>
                            03/2023
                          </td>
                        </tr>
                      </tbody>
                    </>
                  ))}
                </table>
              </CustomTable>
            </SessionDrawer> */}

            <Footer>
              <span>Este documento não substitui estudos ambientais exigidos. Seu conteúdo é baseado nas fontes indicadas, e o uso das informações é de responsabilidade do usuário. A precisão dos resultados pode variar devido ao sistema considerar valores com apenas duas casas decimais. (ex: 0,00% pode ser resultado de 0,009%).</span>              
            </Footer>
          </Body>
        </Content>
      </CustomDrawer>
    </div>
  );
};

Ronmentalrestrict.properties = {
  id: 'CPN-TB-P-PROTECTED-AREAS-REPORT',
  alias: 'Relatório Preliminar de Análise Ambiental',
  description: 'Relatório Preliminar de Análise Ambiental',
};

export default Ronmentalrestrict;
